import React from "react";
import OverlapSection from "../section/OverlapSection";
import imageSrc from "../../assets/images/missing_image.png";

const Missing = () => {
  return (
    <div className="toLeft">
      <OverlapSection
        layoutClass="toLeft"
        imageUrl={imageSrc}
        mainTitle={"AREN'T THEY STRAY ?\n MAY BE LOST."}
        backText={"They have lost, someone might be waiting for them & they can't tell but we can. \n Be there voice they will reach their destination."}
        // buttonLink="/book"
      />
    </div>
  );
};

export default Missing;
